import React from "react";

import Modal from "components/common/Modal";
import TaxYearSelect from "components/common/inputs/Select/TaxYearSelect";

import useModal from "hooks/useModal";

export const CHANGE_DOCUMENT_TAX_YEAR_MODAL_NAME = "CHANGE_DOCUMENT_TAX_YEAR";

const ChangeTaxYearModal = () => {
  const { options = {}, close, setDisabled } = useModal(CHANGE_DOCUMENT_TAX_YEAR_MODAL_NAME);
  const { currentValue, onChange } = options;

  const [selected, setSelected] = React.useState(
    currentValue || new Date().getFullYear().toString(),
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      onChange?.(selected);
      close();
    } finally {
      setDisabled(false);
    }
  };

  return (
    <Modal
      size="sm"
      name={CHANGE_DOCUMENT_TAX_YEAR_MODAL_NAME}
      form={CHANGE_DOCUMENT_TAX_YEAR_MODAL_NAME}
      title="Change Tax Year"
      submitButtonTitle="Apply"
      showCloseButton
      onSubmitClick={handleSubmit}
    >
      <form id={CHANGE_DOCUMENT_TAX_YEAR_MODAL_NAME} onSubmit={handleSubmit}>
        <TaxYearSelect
          label="Tax Year"
          value={selected}
          onChange={({ value }) => setSelected(value)}
        />
      </form>
    </Modal>
  );
};

export default ChangeTaxYearModal;
